import { Injectable, inject } from '@angular/core';

import { StorageService } from '@uoa/auth';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class AppStorageService implements StorageService {
  private storage = inject(Storage);

  constructor() {
    this.storage.create();
  }

  getItem(key: string): Promise<unknown> {
    return this.storage.get(key);
  }

  setItem(key: string, val: unknown): Promise<void> {
    return this.storage.set(key, val);
  }

  removeItem(key: string): void {
    this.storage.remove(key);
  }
}
